import React from 'react';
import styled from 'styled-components';
import { Text } from '@ardoq/typography';
import { space } from '@ardoq/design-tokens';

const WarningText = styled(Text)<{ $marginBottom?: string }>`
  margin-top: ${space.xsmall};

  ${({ $marginBottom }) =>
    $marginBottom ? `margin-bottom: ${$marginBottom};` : ''}
`;

export function ValueWarningMessage({
  message,
  marginBottom,
  color = 'textWarning',
}: {
  message?: string;
  marginBottom?: string;
  color?: 'textWarning' | 'textError';
}) {
  if (!message) {
    return null;
  }

  return (
    <WarningText variant="caption" color={color} $marginBottom={marginBottom}>
      {message}
    </WarningText>
  );
}
